import { render } from "./Payment.vue?vue&type=template&id=0e295e76"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
script.render = render

export default script